// extracted by mini-css-extract-plugin
module.exports = {"smallPadd":"Quote_smallPadd__swE_x","text":"Quote_text__2l8Cx"};